import { combineReducers } from 'redux';
import onboardingReducer from './onboarding';
import dashboardReducer from './dashboard';
import configReducer from './config';
import notificationReducer from './notification';
import stackedNotificationsReducer from '@common/reducers/stackedNotifications';

const renterReducer = combineReducers({
  onboarding: onboardingReducer,
  dashboard: dashboardReducer,
  config: configReducer,
  notification: notificationReducer,
  stackedNotifications: stackedNotificationsReducer,
});

const paymentsReducer = combineReducers({
  renter: renterReducer,
});

export { renterReducer, paymentsReducer };
